import type { SVGProps, FC } from "react"

const SvgShare: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 17.082 14.231"
    {...props}
  >
    <path
      data-name="Icon ionic-ios-share-alt"
      d="M16.93 5.978 10.655.108a.321.321 0 0 0-.249-.107c-.2.009-.445.147-.445.356v2.944a.19.19 0 0 1-.16.182c-6.24.956-8.868 5.626-9.8 10.474-.036.191.222.369.342.218a11.342 11.342 0 0 1 9.429-4.777.22.22 0 0 1 .187.213v2.891a.382.382 0 0 0 .645.236l6.32-5.973a.491.491 0 0 0 .156-.374.6.6 0 0 0-.15-.413Z"
    />
  </svg>
)

export default SvgShare
